import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoMarca } from '../../servicos/srv.produto';


@Component({
  selector: 'tsv2-mrc-listar',
  templateUrl: './listar.component.html',
  providers: [ ServicoMsg, ServicoMarca ]
})
export class MarcaListarComponent implements OnInit {
  @Input() items: any[];
  @Input() pagina: number;

  @Output() trocar = new EventEmitter();

  constructor(
    private spinner: NgxSpinnerService,
    private servicoMsg: ServicoMsg,
    private servicoMarca: ServicoMarca
  ) {
    this.items = [];
    this.pagina = 1;
  }

  ngOnInit() {
  }

  removerMarca(id){
    let titulo = 'Remover a marca?';
    let texto = 'Marca removida com sucesso!';
    this.servicoMsg.exibeAlerta(titulo, id, this.servicoMarca, texto).then(r1 => {
      if (r1.success){
        this.trocar.emit(this.pagina);
      }
    }, (err: any) => {
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
